import { Link } from "react-router";
import Logo from "./Logo";

export function LogoButton() {
  return (
    <Link to="/" className="flex items-center">
      <div className="w-36 h-8">
        <Logo />
      </div>
    </Link>
  );
}
